import { supabase } from '../supabase';
import { runPrompt } from '../ai';
export async function listDisputes(orgId) {
    const { data, error } = await supabase.from('disputes')
        .select('*').eq('org_id', orgId)
        .order('updated_at', { ascending: false });
    if (error)
        throw error;
    return (data ?? []);
}
export async function getDispute(id) {
    const { data, error } = await supabase.from('disputes').select('*').eq('id', id).maybeSingle();
    if (error)
        throw error;
    return data;
}
export async function createDispute(params) {
    const { data, error } = await supabase.from('disputes').insert({
        org_id: params.org_id, review_id: params.review_id ?? null,
        claim_summary: params.claim_summary, evidence_urls: params.evidence_urls ?? [],
        status: 'draft',
    }).select().single();
    if (error)
        throw error;
    return data;
}
export async function generateAIDraft(input) {
    const r = await runPrompt('dispute-resolution', {
        platform: input.platform,
        rating: String(input.rating),
        author: input.author,
        posted_at: new Date().toISOString(),
        review_body: input.review_body,
        business_context: input.business_context,
        evidence_summary: input.evidence_summary,
        brand_voice: input.brand_voice,
        max_words: '120',
    }, { org_id: input.org_id });
    return { text: r.text, model: r.model, prompt_id: 'dispute-resolution' };
}
export async function saveDraft(id, text, model, prompt_id) {
    const { error } = await supabase.from('disputes').update({
        ai_draft: text, ai_model: model, ai_prompt_id: prompt_id, updated_at: new Date().toISOString(),
    }).eq('id', id);
    if (error)
        throw error;
}
export async function setStatus(id, status) {
    const patch = { status, updated_at: new Date().toISOString() };
    if (status === 'resolved')
        patch.resolved_at = new Date().toISOString();
    const { error } = await supabase.from('disputes').update(patch).eq('id', id);
    if (error)
        throw error;
}
export async function setFinalReply(id, text) {
    const { error } = await supabase.from('disputes').update({ final_reply: text }).eq('id', id);
    if (error)
        throw error;
}
